import { render } from "./NewLevel.vue?vue&type=template&id=65ad74f0"
import script from "./NewLevel.vue?vue&type=script&lang=js"
export * from "./NewLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__